import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: 'Sem restrição de SKUs' },
			{ value: '1', label: 'Lotes distintos do SKU' },
			{ value: '2', label: 'Apenas mesmo lote' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

